export default "/images/loading.gif?fcba57cdb89652f9bb54271cc5a9cc0e";